import React, { useState, useEffect } from 'react';
import CareersHeroForm from './CareersHeroForm';
import CareersPhilosophyForm from './CareersPhilosophyForm';
import CareersPositionsForm from './CareersPositionsForm';
import CareersOpportunitiesForm from './CareersOpportunitiesForm';
import { 
  Briefcase, 
  HeartHandshake, 
  UserPlus, 
  GraduationCap 
} from 'lucide-react';
import './FormsUnified.css';

const TABS = [
  { id: 'hero', title: 'Hero Section', icon: Briefcase, component: CareersHeroForm },
  { id: 'philosophy', title: 'Hiring Philosophy', icon: HeartHandshake, component: CareersPhilosophyForm },
  { id: 'positions', title: 'Open Positions', icon: UserPlus, component: CareersPositionsForm },
  { id: 'opportunities', title: 'Internships & Volunteering', icon: GraduationCap, component: CareersOpportunitiesForm }
];

export default function CareersForm({ apiBase, activeTab }) {
  const getInitialTab = () => {
    if (activeTab === 'cms-car-philosophy' || activeTab === 'cms-car-culture' || activeTab === 'careers-philosophy' || activeTab === 'philosophy') return 'philosophy';
    if (activeTab === 'cms-car-positions' || activeTab === 'cms-car-openings' || activeTab === 'careers-positions' || activeTab === 'positions') return 'positions';
    if (activeTab === 'cms-car-opportunities' || activeTab === 'careers-opportunities' || activeTab === 'opportunities') return 'opportunities';
    return 'hero';
  };

  const [currentTab, setCurrentTab] = useState(getInitialTab);

  useEffect(() => {
    setCurrentTab(getInitialTab());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const activeTabConfig = TABS.find(t => t.id === currentTab) || TABS[0];
  const ActiveComponent = activeTabConfig.component;

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.id === currentTab;

          return (
            <button
              key={tab.id}
              type="button"
              className={`tab-pill-btn ${isActive ? 'active' : ''}`}
              onClick={() => setCurrentTab(tab.id)}
            >
              <Icon className="w-4 h-4 mr-2" size={16} />
              <span>{tab.title}</span>
            </button>
          );
        })}
      </div>

      {/* Render Active Section Sub-Form */}
      <div className="unified-tab-content">
        <ActiveComponent apiBase={apiBase} />
      </div>
    </div>
  );
}
